import { anywayProducts } from '../../config/anyway';

export function getPaymentType(plan, isYearly = false) {
  if (plan.paymentType) return plan.paymentType;
  if (plan.isOneTime) return 'onetime_basic';
  return `${plan.name.toLowerCase()}_${isYearly ? 'yearly' : 'monthly'}`;
}

export function getProviderPrice(plan, provider, isYearly = false, environment = process.env.NODE_ENV === 'production' ? 'production' : 'development') {
  if (plan.isOneTime) {
    return plan.priceId?.[provider]?.[environment] || plan.prices?.[provider]?.oneTime?.[environment] || '';
  }
  return plan.prices?.[provider]?.[isYearly ? 'yearly' : 'monthly']?.[environment] || '';
}

export function isConfiguredAnywayProduct(product, isOneTime = false) {
  if (isOneTime) return product?.enabled === true;
  if (!product?.productId || typeof product.productId !== 'string' || !product.productId.trim()) return false;
  // A product ID is sufficient: checkout loads the current payment link on the server.
  if (!product.paymentLinkUrl) return true;
  try {
    const url = new URL(product.paymentLinkUrl);
    return url.protocol === 'https:' && ['pay.anyway.sh', 'app.anyway.sh'].includes(url.hostname) && !url.username && !url.password && !url.port;
  } catch { return false; }
}

export function getAvailableProviders(config, plan, isYearly = false, products = anywayProducts) {
  return Object.entries(config.payments.providers)
    .filter(([id, provider]) => {
      if (!provider.enabled) return false;
      if (!plan) return true;
      return id === 'anyway'
        ? isConfiguredAnywayProduct(products[getPaymentType(plan, isYearly)], Boolean(plan.isOneTime))
        : Boolean(getProviderPrice(plan, id, isYearly));
    })
    .sort(([, a], [, b]) => (a.priority ?? 999) - (b.priority ?? 999))
    .map(([id, provider]) => ({ id, ...config.payments.methods[id], ...provider }));
}

// Server catalog: amount and credits always come from local configuration.
export function getPaymentProduct(config, paymentType, products = anywayProducts) {
  for (const plan of config.stripe.plans) {
    for (const isYearly of [false, true]) {
      if (getPaymentType(plan, isYearly) !== paymentType) continue;
      return {
        ...products[paymentType], paymentType, productName: `Wan22.IO - ${plan.name}`,
        // Match the yearly total shown by SimplePricing (.toFixed(0)), not its monthly average.
        amountCents: isYearly ? Math.round(plan.yearlyPrice * 12) * 100 : Math.round(plan.price * 100),
        credits: isYearly ? plan.yearlyCredits : plan.credits,
        isOneTime: Boolean(plan.isOneTime), currency: 'usd',
        interval: plan.isOneTime ? null : isYearly ? 'year' : 'month',
      };
    }
  }
  const pack = config.creditPacks.packs.find(pack => pack.paymentType === paymentType);
  return pack ? {
    ...products[paymentType], paymentType, productName: `Wan22.IO - ${pack.credits.toLocaleString('en-US')} Credits`,
    amountCents: Math.round(pack.price * 100), credits: pack.credits,
    isOneTime: true, currency: 'usd', interval: null,
  } : null;
}
